import { Theme } from '@mui/material/styles'
import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    info: {
        '& .MuiTypography-root': {
            color: palette.text.primary,
        },
    },
    titleHeader: {
        m: (theme: Theme): string => theme.spacing(1, 0, 2, 0),
    },
    subtitle: {
        color: 'text.primary',
    },
}
